import { ComponentPropsWithoutRef } from 'react';

export const VideoIconV2 = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 512 512">
      <rect width="512" height="512" rx="120.68" />
      <path
        fill="#000000"
        d="M401.79 171.83a44.72 44.72 0 0 0-42.41-3.7l-32.45 14a77.38 77.38 0 0 0-71.33-47.57h-88.33A77.35 77.35 0 0 0 90 211.83v88.34a77.35 77.35 0 0 0 77.27 77.26h88.33a77.38 77.38 0 0 0 71.33-47.57l32.45 14A44.85 44.85 0 0 0 422 302.7v-93.4a44.7 44.7 0 0 0-20.21-37.47zM255.6 335.2h-88.33a35.07 35.07 0 0 1-35-35v-88.37a35.07 35.07 0 0 1 35-35h88.33a35.06 35.06 0 0 1 35 34.94 2.72 2.72 0 0 0 0 .28v88a2.72 2.72 0 0 0 0 .28 35.06 35.06 0 0 1-35 34.87zm124.17-32.5a2.62 2.62 0 0 1-3.65 2.4l-43.25-18.68v-60.84l43.25-18.68a2.62 2.62 0 0 1 3.65 2.4z"
        data-original="#000000"
      />
    </svg>
  );
};
